export default {
  required: "This field is required",
  maxLength: "Maximum length: {length}",
  minLength: "Minimum length: {length}",
};
